import { render, staticRenderFns } from "./IVCFleetSettings.vue?vue&type=template&id=b5851258&scoped=true&"
import script from "./IVCFleetSettings.vue?vue&type=script&lang=js&"
export * from "./IVCFleetSettings.vue?vue&type=script&lang=js&"
import style0 from "./IVCFleetSettings.vue?vue&type=style&index=0&id=b5851258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5851258",
  null
  
)

export default component.exports